import React from "react";
import { SEO, DynamicScript } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class ReviewsPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://www.tommyssalon.com/reviews/"}
        />
        <Grid
          className={"custom-page-reviews custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"cnhmogalfmieejnc"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"flcedlcfohpnemji"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__562d1dfc-9fa6-4ecf-bfdd-efbe2cf05dc4"}
                >
                  <div>
                    <iframe
                      width={"100%"}
                      height={"600"}
                      src={
                        "https://tommyssalon.aura.site/reviews_embed.php?loc=20191"
                      }
                      id={"aura_reviews"}
                      frameborder={"0"}
                    />
                    <DynamicScript
                      type={"application/javascript"}
                      delay={300}
                      body={
                        "window.addEventListener('message', function(e) {if (e.data && e.data.action === 'aura_resize' && e.data.height > 0) {var iframe = document.getElementById('aura_reviews');if (iframe) {iframe.style.height = e.data.height + 'px';}}});"
                      }
                    />
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 38015 }) {
      title
      seoTitle
      description
    }
  }
`;
